import React from 'react';
import dayjs from 'dayjs';
import { useHistory } from 'react-router-dom';
import {
    Box,
    Chip,
    Grid,
    Typography,
    List,
    ListItem,
    Paper,
    IconButton,
} from '@material-ui/core';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

export function getPriorityChip(priority) {
    if (priority === '1') {
        return <Chip label={priority} size='small' style={{ color: '#fff', backgroundColor: "#ef5350" }} />;
    }
    if (priority === '2') {
        return <Chip label={priority} size='small' style={{ color: '#fff', backgroundColor: "#ff9800" }} />;
    }
    if (priority === '3') {
        return <Chip label={priority} size='small' style={{ color: '#fff', backgroundColor: "#03a9f4" }} />;
    }
    return <Chip label="N/A" />;
};

function WorkshopOrderListItem({ workshopOrder, displayVehicle }) {
    const history = useHistory();

    const { priority = 'N/A', order = {} } = workshopOrder;
    const {
        name = 'N/A',
        createdOn = null,
        reporter: { name: reporterName = 'N/A' } = {},
        vehicle: { number = 'N/A', vehicleType: { type = 'N/A' } = {} } = {},
    } = order;
    const goToWorkshopOrder = (order) => {
        if (!order || !order.vehicle) {
            return;
        }
        history.push(`/workshop/${order.vehicle.id}/${order.id}`, { workshopOrder: workshopOrder });
    };
    const formatDaysElapsed = (date) => {
        const daysAgo = dayjs().diff(dayjs(date), 'day');
        return daysAgo === 0 ? 'Today' : daysAgo === 1 ? '1d' : `${daysAgo}d`;
    };

    return (
        <ListItem disableGutters>
            <Box p={2} width='100%' component={Paper} variant='outlined' display='flex' alignItems='center' elevation={0} borderRadius={15}>
                <Grid container direction='column' spacing={1}>
                    {/* Order No & Priority */}
                    <Grid item>
                        <Box display='flex' justifyContent='space-between'>
                            <Box display='flex' alignItems='center' flexWrap='wrap'>
                                {displayVehicle ? (
                                    <Box mr={1}>
                                        <Typography variant='body2' style={{ fontWeight: 'bold' }}>
                                            {`${type} - ${number}`}
                                        </Typography>
                                    </Box>
                                ) : (
                                    <Box mr={1}>
                                        <Typography variant='body1' style={{ fontWeight: 'bold' }}>
                                            {`#${name}`}
                                        </Typography>
                                    </Box>
                                )}
                                <Box>
                                    <Typography variant='body2' color='textSecondary'>
                                        {`• ${formatDaysElapsed(createdOn)}`}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box>
                                {getPriorityChip(priority)}
                            </Box>
                        </Box>
                    </Grid>

                    {/* Reporter name & service button */}
                    <Grid item>
                        <Box display='flex' justifyContent='space-between'>
                            <Box>
                                <Chip label={reporterName} variant='outlined' size='small' />
                            </Box>
                            <Box>
                                <IconButton fontSize='small' onClick={() => goToWorkshopOrder(workshopOrder.order)} style={{ padding: 0 }}>
                                    <ArrowForwardIosIcon fontSize='small' />
                                </IconButton>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </ListItem>
    );
};

function WorkshopOrdersList({ orders, displayVehicle }) {
    const sortWorkOrders = (workOrders, keys = [], orders = []) => {
        return [...workOrders].sort((a, b) => {
            for (let i = 0; i < keys.length; i++) {
                const key = keys[i];
                const order = orders[i] || 'asc';

                let comparison = 0;
                if (key === 'priority') {
                    comparison = parseInt(a.priority) - parseInt(b.priority);
                } else if (key === 'createdOn') {
                    comparison = dayjs(a).unix() - dayjs(b).unix();
                }
                if (order === 'desc') {
                    comparison *= -1;
                }
                if (comparison !== 0) {
                    return comparison;
                }
            }
            return 0;
        });
    };

    // sorted by priority and createdOn
    const sortedOrders = sortWorkOrders(orders, ['priority', 'createdOn'], ['asc', 'asc']);

    return (
        <List>
            {sortedOrders.map((o) => o && o.order?.id && (
                <WorkshopOrderListItem key={o.order.id} workshopOrder={o} displayVehicle={displayVehicle} />
            ))}
        </List>
    );
};

export default WorkshopOrdersList;
